// ./src/contexts/EventSetupCatalogContext/EventSetupCatalogContext.tsx
//
// Thin context wrapper around `useEventSetupCatalog` (ROADMAP A2b #62). Mounted APP-WIDE: the wizard, the event card,
// the dashboard header, Home and Details & Settings all name an event's type, and they must all read ONE catalog.
import React, { createContext, useContext } from 'react';

import { useEventSetupCatalog, UseEventSetupCatalogOptions, UseEventSetupCatalogReturn } from '@/hooks/useEventSetupCatalog';

const EventSetupCatalogContext = createContext<UseEventSetupCatalogReturn | null>(null);

export interface EventSetupCatalogProviderProps extends UseEventSetupCatalogOptions {
  children: React.ReactNode;
}

export const EventSetupCatalogProvider: React.FC<EventSetupCatalogProviderProps> = ({ children, ...options }) => {
  const value = useEventSetupCatalog(options);

  return <EventSetupCatalogContext.Provider value={value}>{children}</EventSetupCatalogContext.Provider>;
};

export const useEventSetupCatalogContext = (): UseEventSetupCatalogReturn => {
  const context = useContext(EventSetupCatalogContext);

  if (!context) {
    throw new Error(
      'useEventSetupCatalogContext must be used within an <EventSetupCatalogProvider>. ' +
        'Wrap your component tree with <EventSetupCatalogProvider> to fix this.',
    );
  }

  return context;
};

/** Null-tolerant read — a card rendered outside the provider shows no emoji rather than crashing. */
export const useOptionalEventSetupCatalogContext = (): UseEventSetupCatalogReturn | null => {
  return useContext(EventSetupCatalogContext);
};
